import React, {useEffect, useRef} from 'react';
import { Editor } from '@tinymce/tinymce-react';

export default function App() {
    const editorRef = useRef(null);
    const log = () => {
      if (editorRef.current) {
        console.log(editorRef.current.getContent());
      }
    };
    useEffect(() => {
        // https://www.tiny.cloud/docs/tinymce/latest/react-cloud/
      console.log(process.env)

        return ;
    }, [])

    return (
        <div className="editorScreenContainer">
            <div className="editorScreenContent">
                <Editor
                    apiKey={process.env.REACT_APP_TINY_API_KEY}
                    onInit={(_evt, editor) => editorRef.current = editor}
                    initialValue="<p>This is the initial content of the editor.</p>"
                    style={{background: 'white'}}
                    init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                    }} />
                <button onClick={log}>Log editor content</button>
            </div>
        </div>
    );
}